import { createStyles } from 'antd-style';

import abstractBackground from '../resources/img/abstract-background.jpg';
import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../theme';
import { absolute, spaceBetween } from '../styles/mixins';
import { responsiveMdVsLg } from '../styles/responsiveMixins';

export const useTermsOfServicePageStyles = createStyles(({ token }) => ({
  termsOfServicePage: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    ...responsiveMdVsLg(
      {
        padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
      },
      { padding: `${ThemeSpaces.SPACE_XL}px ${ThemeSpaces.SPACE_NORM_20}px` }
    ),

    '&::before': {
      content: "' '",
      ...absolute(0),
      opacity: 0.65,
      backgroundImage: `url('${abstractBackground}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      backgroundColor: ThemeColors.COLOR_WHITE3,
    },
  },

  container: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    height: '100%',
    maxHeight: 800,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    boxShadow: `2px 2px 25px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH7, 0.35)}`,

    ...responsiveMdVsLg(
      { padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM}px` },
      {
        padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_30}px`,
      }
    ),
  },

  logo: {
    marginBottom: ThemeSpaces.SPACE_NORM_20,
  },

  threeLinesAndScrollbar: {
    ...responsiveMdVsLg(
      {
        marginLeft: -ThemeSpaces.SPACE_NORM,
        marginRight: -ThemeSpaces.SPACE_NORM,
      },
      {
        marginLeft: -ThemeSpaces.SPACE_NORM_30,
        marginRight: -ThemeSpaces.SPACE_NORM_30,
      }
    ),
  },

  threeLines: {
    marginTop: ThemeSpaces.SPACE_NORM,
    marginBottom: ThemeSpaces.SPACE_NORM_15,
  },

  content: {
    fontWeight: 500,

    p: {
      marginBottom: ThemeSpaces.SPACE_MD,
    },

    h1: {
      fontSize: token.fontSizeHeading1,
    },
    h2: {
      fontSize: token.fontSizeHeading2,
    },
    h3: {
      fontSize: token.fontSizeHeading3,
    },

    'h1, h2, h3': {
      lineHeight: 1,
      fontWeight: 300,
      textTransform: 'uppercase',
      marginBottom: ThemeSpaces.SPACE_NORM,
    },

    'ul, ol': {
      marginBottom: ThemeSpaces.SPACE_NORM_15,
      paddingLeft: 16 + ThemeSpaces.SPACE_NORM,
    },

    li: {
      paddingLeft: ThemeSpaces.SPACE_NORM_20 - 12,
    },

    ...responsiveMdVsLg(
      { padding: `0 ${ThemeSpaces.SPACE_NORM}px` },
      { padding: `0 ${ThemeSpaces.SPACE_NORM_30}px` }
    ),
  },

  checkbox: {
    '.ant-checkbox-inner': {
      borderColor: token.colorPrimary,
    },
    label: {
      fontSize: token.fontSizeLG,
      color: token.colorPrimary,
    },
    '.ant-checkbox + span': {
      paddingLeft: ThemeSpaces.SPACE_SM,
    },
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',

    button: {
      width: 110,
      ...responsiveMdVsLg(
        spaceBetween(ThemeSpaces.SPACE_NORM),
        spaceBetween(ThemeSpaces.SPACE_NORM_20)
      ),
    },
  },
}));
